import React, { Component } from 'react';
import { Modal, Spin, Row, Col, Input, message, Button, Icon, Tabs, Tooltip } from 'antd';
import API_URL from '../../../../common/url';
import $ from '../../../../common/AjaxRequest';
import VisitEditableTable from './VisitEditableTable';
import { getMatchOption } from '../../../shared/selectFn';


const { TabPane } = Tabs;


const tumour = ['Tumour_Single', 'Tumour_NoSingle'];
const no_tumour = ['NoTumour_Single', 'NoTumour_NoSingle'];

class PlanVisitParams extends Component {
    state = {
        visible: false,
        loading: false,
        data: {},
        stageList: [],
        activeKey: '',
        selectKey: this.props.visitGroupingId,
        planName: '',
        visitPlanType: '',
        groupings: [],
        planVisitTypeGroupings: [],
        canEdit: false,
        reRender: true,
        pkTypeList: [],
    }

    show = () => {
        this.setState({
            data: {},
            visible: true,
            activeKey: '',
        }, () => {
            this.queryInvStatus();
            this.queryByParams();
        });
    }

    hide = () => {
        this.setState({ visible: false }, () => {
            this.visitRef.hide();
        });

    }


    componentDidMount() {
        //在组件加载完成做操作
        this.queryInvStatus();

    }

    componentDidCatch() {

    }

    componentWillUnmount() {
        //在组件卸载做操作
    }

    componentDidUpdate() {
        //手动控制reader()
    }

    queryInvStatus = () => {
        const { invId } = sessionStorage;
        this.setState({ loading: true });
        $.sendRequest({
            method: 'POST',
            url: API_URL.plan.queryInvStatus,
            data: {
                investigationId: invId,
                publishStatus: this.published ? 'UNPUBLISHED' : 'PUBLISHED',
            },
            dataType: 'json',
            doneResult: res => {
                this.setState({ loading: false, visitPlanType: res.data },()=>{this.props.getInvPlanStatus(res);this.loadData()});
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        });

    }

    queryByParams = () => {
        $.sendRequest({
            method: 'POST',
            url: API_URL.investigation.queryByParams,
            data: {
                typeName: 'PLAN_VISIT_PARAM_PK'
            },
            dataType: 'json',
            doneResult: res => {
                const { typeConfigureList } = res;
                const { pkTypeList } = this.state;
                (typeConfigureList || []).map(el => {
                    pkTypeList.push({
                        value: el.typeConfigureId,
                        label: el.typeValue,
                    })
                })
                this.setState({ pkTypeList })
            }
        });
    }


    handleTabChange = (activeKey) => {
        if (activeKey != 'plus-circle-o') {
            this.setState({ activeKey },
                () => {
                    this.loadData(activeKey);
                });
        }
    }

    loadData = (visitGroupingId) => {

        this.setState({ loading: true });
        const data = {};
        data['visitGroupingId'] = visitGroupingId;
        const { visitPlanType } = this.state;
        data['invPlanStatus'] = visitPlanType;
        $.sendRequest({
            method: 'POST',
            url: API_URL.plan.queryPlanVisitTypeGroupingByGroupingId,
            data: { ...data },
            dataType: 'json',
            doneResult: res => {
                this.setState({
                    loading: false,
                    groupings: res.groupings || {}
                });
                this.reRender();
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        });


    }


    handleChange = (value, key) => {
        const { data } = this.state;
        switch (key) {
            default:
                data[key] = value;
                break;
        }
        this.setState({ data });
    }

    getVisitGroupingDetails = () => {
        return [
            {
                name: '访视类别',
                key: 'visitCategory',
                type: 'input',
                typeProperty: {
                    style: { width: 100 },
                    disabled: true,
                    editable: false,
                },
            }, {
                name: '访视类型',
                key: 'visitConfigName',
                type: 'input',
                typeProperty: {
                    style: { width: 260 },
                    disabled: true,
                    editable: false,
                },
                rules: {
                    required: true,
                }
            }, {
                name: '次数',
                key: 'visitCountNum',
                type: 'input',
                typeProperty: {
                    style: { width: 100 },
                    disabled: false,
                    editable: false,
                },
            }, {
                name: '是否循环访视',
                key: 'isCircularVisit',
                type: 'select',
                typeProperty: {
                    style: { width: 100 },
                    list: [{ label: '循环访视', value: '1' }, { label: '唯一访视', value: '0' }],
                    disabled: true,
                    editable: false,
                },
            }, {
                name: '是否有PK',
                key: 'isPk',
                type: 'select',
                typeProperty: {
                    list: [{ label: '有PK', value: '1' }, { label: '无PK', value: '0' }],
                    style: { width: 80 },
                },
                rules: {
                    required: true,
                }
            }, {
                name: '该访视多久发生一次（月）',
                key: 'visitFrequency',
                type: 'inputNumber',
                typeProperty: {
                    style: { width: 80 },
                    precision: 2,
                    min: 0
                },
                rules: {
                    required: true,
                }
            }, {
                name: '访视工时',
                key: 'visitHour',
                type: 'input',
                typeProperty: {
                    style: { width: 100 },
                    disabled: true,
                    editable: false,
                },
            }, {
                name: '计划访视数',
                key: 'planVisitAmount',
                type: 'input',
                typeProperty: {
                    style: { width: 100 },
                    disabled: false,
                    editable: false,
                },
            }, {
                name: '计划标准访视数',
                key: 'standardVisitAmount',
                type: 'input',
                typeProperty: {
                    style: { width: 110 },
                    disabled: true,
                    editable: false,
                },
            }
        ];
    }

    getVisitGroupingDetailsNoTumour = () => {
        return [
            {
                name: '访视类别',
                key: 'visitCategory',
                type: 'input',
                typeProperty: {
                    style: { width: 100 },
                    disabled: true,
                    editable: false,
                },
            }, {
                name: '访视类型',
                key: 'visitConfigName',
                type: 'input',
                typeProperty: {
                    style: { width: 260 },
                    disabled: true,
                    editable: false,
                },
                rules: {
                    required: true,
                }
            }, {
                name: '次数',
                key: 'visitCountNum',
                type: 'input',
                typeProperty: {
                    style: { width: 100 },
                    disabled: false,
                    editable: false,
                },
            }, {
                name: '访视工时',
                key: 'visitHour',
                type: 'input',
                typeProperty: {
                    style: { width: 100 },
                    disabled: true,
                    editable: false,
                },
            }, {
                name: '计划访视数',
                key: 'planVisitAmount',
                type: 'input',
                typeProperty: {
                    style: { width: 100 },
                    disabled: false,
                    editable: false,
                },
            }, {
                name: '计划标准访视数',
                key: 'standardVisitAmount',
                type: 'input',
                typeProperty: {
                    style: { width: 110 },
                    disabled: true,
                    editable: false,
                },
            }
        ];
    }

    saveVisitPlanSettings = (record) => {

        //必填校验
        const { groupings, visitPlanType } = this.state;
        const { planRandomAmount, earlyExitRatio, earlyExitFinishVisitRatio,
            progressionSurvivalVisitPeriod, planPkAmount, filterImplRate, patientVisitCompletedRate, importFailRate,
            estimatedSurvivalVisitPeriod, haveUnplannedVisitConfigType, unplannedVisitSubjectAmount } = record;


        if (visitPlanType == 'Tumour_Single' || visitPlanType == 'Tumour_NoSingle') {
            if (planRandomAmount == null || planRandomAmount === '') {
                message.error('计划随机(入组)数需必填');
                return;
            }
            if (earlyExitRatio == null || earlyExitRatio === '') {
                message.error('提前退出比例需必填');
                return;
            }
            if (earlyExitFinishVisitRatio == null || earlyExitFinishVisitRatio === '') {
                message.error('提前退出的受试者完成访视比例需必填');
                return;
            }
            if (progressionSurvivalVisitPeriod == null || progressionSurvivalVisitPeriod === '') {
                message.error('预计无进展生存随访期PFS（月）需必填');
                return;
            }
            if (estimatedSurvivalVisitPeriod == null || estimatedSurvivalVisitPeriod === '') {
                message.error('预计中位生存期OS（月）需必填');
                return;
            }
            if (planPkAmount == null || planPkAmount === '') {
                message.error('计划PK例数需必填');
                return;
            }

        }

        if (visitPlanType == 'NoTumour_Single' || visitPlanType == 'NoTumour_NoSingle') {
            if (planRandomAmount == null || planRandomAmount === '') {
                message.error('计划随机(入组)数需必填');
                return;
            }

            if (patientVisitCompletedRate == null || patientVisitCompletedRate === '') {
                message.error('预计完成全部试验流程患者比例必填');
                return;
            }


        }

        //访视类型有计划外访视时必填
        if (haveUnplannedVisitConfigType && (unplannedVisitSubjectAmount == null || unplannedVisitSubjectAmount === '')) {
            message.error('计划外访视受试者例数需必填');
            return;
        }


        this.setState({ loading: true });
        record['invPlanStatus'] = visitPlanType;
        $.sendRequest({
            method: 'POST',
            url: API_URL.plan.savePlanVisitParameterSetting,
            data: { ...record },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({
                    loading: false,
                }, () => this.visitRef.saveSuccess());

                this.loadData();


            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        });



    }

    saveVisitGroupingDetails = (record) => {

        //有无PK必填，无PK 访视发生评率必填

        const { visitPlanType } = this.state;
        const { isPk, visitFrequency } = record;
        if (isPk == null || isPk === '' || isPk == undefined) {
            message.error('是否PK需必填');
            return;
        }
        if (isPk == '0' && (visitFrequency == null || visitFrequency === '')) {
            message.error('无PK下该访视多久发生一次（月）需必填');
            return;
        }
        record['invPlanStatus'] = visitPlanType;
        this.setState({ loading: true });
        $.sendRequest({
            method: 'POST',
            url: API_URL.plan.savePlanVisitTypeGrouping,
            data: { ...record },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({
                    loading: false,
                }, () => this.loadData());
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        });


    }

    getVisitPlanSettingsColumnsTumour = (grouping) => {
        const earlyExitRatioTipInfo = (
            <span>
                本项目预计提前退出的受试<br />
                者，占所有预计入组数的比<br />
                例
            </span>
        );
        const earlyExitRatioTip = <Tooltip placement="top" title={earlyExitRatioTipInfo}>
            <text style={{ marginRight: 4 }}>提前退出比例</text>
            <a><Icon style={{ marginRight: -8, fontSize: '14px', color: '#5750c9' }} type="info-circle-o" /></a>
        </Tooltip>;


        const earlyExitFinishVisitRatioTipInfo = (
            <span>
                本项目提前退出的受试者，<br />
                预计可以完成整个访视计划<br />
                的访视数比例
            </span>
        );
        const earlyExitFinishVisitRatioTip = <Tooltip placement="top" title={earlyExitFinishVisitRatioTipInfo}>
            <text style={{ marginRight: 4 }}>提前退出的受试者完成访视比例</text>
            <a><Icon style={{ marginRight: -8, fontSize: '14px', color: '#5750c9' }} type="info-circle-o" /></a>
        </Tooltip>;
        const { blindType } = sessionStorage ||{};
        const isNotBlind =  blindType == 'NOTBLIND'; // 非盲
        const { preFilter } = grouping || {};
        return [
            {
                name: '计划预筛数',
                key: 'planPreFilterAmount',
                type: preFilter ? 'inputNumber': 'text',
                typeProperty: {
                    style: { width: 80 },
                    precision: 0,
                    min: 0
                },
                rules: {
                    required: false,
                }
            }, {
                name: '计划筛选数',
                key: 'planFilterAmount',
                type: isNotBlind  ? 'inputNumber': 'text',
                typeProperty: {
                    style: { width: 80 },
                    disabled: false,
                    precision: 0,
                    min: 0
                },
            }, {
                name: '计划随机(入组)数',
                key: 'planRandomAmount',
                type: isNotBlind ? 'inputNumber': 'text',
                typeProperty: {
                    style: { width: 80 },
                    disabled: false,
                    precision: 0,
                    min: 0
                },
            }, {
                name: earlyExitRatioTip,
                key: 'earlyExitRatio',
                type: 'inputNumber',
                typeProperty: {
                    style: { width: 85 },
                    precision: 2,
                    min: 0,
                    unit: '%'
                },
                rules: {
                    required: true,
                }
            }, {
                name: earlyExitFinishVisitRatioTip,
                key: 'earlyExitFinishVisitRatio',
                type: 'inputNumber',
                typeProperty: {
                    style: { width: 120 },
                    disabled: false,
                    precision: 2,
                    min: 0,
                    unit: '%'
                },
            }, {
                name: '预计无进展生存随访期PFS（月）',
                key: 'progressionSurvivalVisitPeriod',
                type: 'inputNumber',
                typeProperty: {
                    style: { width: 80 },
                    disabled: false,
                    precision: 2,
                    min: 0
                },
            }, {
                name: '预计中位生存期OS（月）',
                key: 'estimatedSurvivalVisitPeriod',
                type: 'inputNumber',
                typeProperty: {
                    style: { width: 80 },
                    disabled: false,
                    precision: 2,
                    min: 0
                },
            }, {
                name: '计划PK例数',
                key: 'planPkAmount',
                type: 'inputNumber',
                typeProperty: {
                    style: { width: 80 },
                    disabled: false,
                    precision: 0,
                    min: 0,
                    isTomour: true
                },
            }, {
                name: '计划外访视受试者例数',
                key: 'unplannedVisitSubjectAmount',
                type: 'inputNumber',
                typeProperty: {
                    style: { width: 80 },
                    disabled: false,
                    precision: 0,
                    min: 0
                },
            }
        ];
    }

    getVisitPlanSettingsColumnsNoTumour = (grouping) => {
        const patientVisitCompletedRateInfo = <span>
            本项目所有入组的受试者，<br />
            预计完成整个访视计划的平<br />
            均访视数比例
        </span>

        const patientVisitCompletedRateTip = <Tooltip placement='top' title={patientVisitCompletedRateInfo}>
            <text style={{ marginRight: 4 }}>预计完成全部试验流程患者比例（%）</text>
            <a><Icon style={{ marginRight: -8, fontSize: '14px', color: '#5750c9' }} type="info-circle-o" /></a>
        </Tooltip>

        const pkTypeTipInfo = (
            <span>
                100%病例PK：100%病例数均参与PK，PK访视为部分访视；<br />
                部分病例PK：方案类型相同，部分病例参与部分访视PK；<br />
            </span>
        );
        const pkTypeTip = <Tooltip placement="top" title={pkTypeTipInfo}>
            <text style={{ marginRight: 4 }}>PK类型</text>
            <a><Icon style={{ marginRight: -8, fontSize: '14px', color: '#5750c9' }} type="info-circle-o" /></a>
        </Tooltip>;
        const { blindType } = sessionStorage ||{};
        const isNotBlind =  blindType == 'NOTBLIND'; // 非盲
        const { preFilter, setting } = grouping || {};
        const { havePkVisitConfigType } = setting || {};
        return [
            {
                name: '计划预筛数',
                key: 'planPreFilterAmount',
                type: preFilter ? 'inputNumber' : 'text',
                typeProperty: {
                    list: [{ label: '是', value: '1' }, { label: '否', value: '0' }],
                    style: { width: 80 },
                    precision: 0,
                    min: 0
                },
                rules: {
                    required: false,
                }
            }, {
                name: '计划随机(入组)数',
                key: 'planRandomAmount',
                type: isNotBlind ? 'inputNumber' : 'text',
                typeProperty: {
                    style: { width: 80 },
                    disabled: false,
                    precision: 0,
                    min: 0
                },
            }, {
                name: '预计筛选成功实现率（%）',
                key: 'filterImplRate',
                type: 'text',
                typeProperty: {
                    style: { width: 80 },
                    precision: 2,
                    min: 0,
                    unit: '%'
                },
                rules: {
                    required: true,
                }
            }, {
                name: '导入失败率',
                key: 'importFailRate',
                type: 'inputNumber',
                typeProperty: {
                    style: { width: 80 },
                    disabled: false,
                    precision: 2,
                    min: 0,
                    unit: '%'
                },
            }, {
                name: patientVisitCompletedRateTip,
                key: 'patientVisitCompletedRate',
                type: 'inputNumber',
                typeProperty: {
                    style: { width: 100 },
                    disabled: false,
                    precision: 2,
                    min: 0,
                    unit: '%'
                },
            }, {
                name: pkTypeTip,
                key: 'pkTypeId',
                type: 'radio',
                typeProperty: {
                    style: { width: 120 },
                    editable: havePkVisitConfigType,
                    list: this.state.pkTypeList,
                },
                rules: {
                    required: havePkVisitConfigType,
                }
            }, {
                name: '计划PK例数',
                key: 'planPkAmount',
                type: 'inputNumber',
                typeProperty: {
                    style: { width: 80 },
                    disabled: false,
                    precision: 0,
                    min: 0,
                    isTomour: false
                },
            }, {
                name: '计划外访视受试者例数',
                key: 'unplannedVisitSubjectAmount',
                type: 'inputNumber',
                typeProperty: {
                    style: { width: 80 },
                    disabled: false,
                    precision: 0,
                    min: 0
                },
            }
        ];
    }

    reRender = () => {
        this.setState({
            reRender: false
        }, () => {
            this.setState({
                reRender: true
            })
        })
    }
    getContent = (visitGroupingId) => {
        const { groupings, activeKey, visitPlanType, reRender } = this.state;
        if (visitGroupingId == activeKey || activeKey == '') {

            const grouping = getMatchOption(groupings, 'visitGroupingId', visitGroupingId);
            const settings = [];
            settings.push(grouping.setting)
            const { preFilter, setting } = grouping || {};
            const isTomour = tumour.some(i => i == visitPlanType);
            return (
                <div>
                    <div style={{ marginBottom: 20 }}>
                        {
                            reRender && <VisitEditableTable
                                columns={isTomour ? this.getVisitPlanSettingsColumnsTumour({preFilter}) : this.getVisitPlanSettingsColumnsNoTumour({preFilter, setting})}
                                scrollY={scrollY}
                                dataSource={settings}
                                onChange={dataSource => onChange(dataSource, key, type)}
                                save={this.saveVisitPlanSettings}
                                edit={true}

                                ref={el => this.visitRef = el}
                            />
                        }
                    </div>
                    <div>
                        {
                            reRender && <VisitEditableTable
                                columns={isTomour ? this.getVisitGroupingDetails() : this.getVisitGroupingDetailsNoTumour()}
                                scrollY={scrollY}
                                dataSource={(grouping || {}).planVisitTypeGroupings}
                                onChange={dataSource => onChange(dataSource, key, type)}
                                save={this.saveVisitGroupingDetails}
                                edit={false}
                                isTomour={isTomour}
                            />
                        }
                    </div>
                </div>
            );
        } else {
            return null;
        }

    }

    getVisitGroupingPlan = () => {

    }

    render() {
        const { panes, visitGroupingId } = this.props;
        const { visible, loading, activeKey } = this.state;
        return (

            <div className='plan_visit_home'>
                <Modal
                    title="计划访视参数设置"
                    visible={visible}
                    onCancel={this.hide}
                    cancelText='关闭'
                    maskClosable={false}
                    width="1150px"
                    height="700px"
                    footer={<Button onClick={this.hide}>关闭</Button>}
                    className="plan-visitType"
                    bodyStyle={{ maxHeight: 700 }}
                >


                    <Spin spinning={loading}>
                        <Tabs
                            hideAdd
                            activeKey={activeKey || visitGroupingId}
                            type="editable-card"
                            onEdit={this.handleTabAction}
                            onChange={this.handleTabChange}
                        >
                            {
                                panes.map((pane, index, array) => {
                                    const { visitGroupingId, visitGroupingName } = pane;
                                    let title = visitGroupingName;
                                    return (
                                        <TabPane
                                            key={String(visitGroupingId)}
                                            tab={title}
                                            closable={false}
                                        >
                                            {this.getContent(visitGroupingId)}
                                        </TabPane>
                                    );
                                })
                            }

                        </Tabs>
                    </Spin>

                </Modal>
            </div>
        );
    }
}

export default PlanVisitParams;


// WEBPACK FOOTER //
// ./src/components/executeMgr/visitPeriodPlan/components/PlanVisitParams.js